import { useUrlSourcesStore } from '@/store/urlSourcesStore';
import { usePagesStore } from '@/store/pagesStore';
import { watch, computed } from 'vue';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import { extractMetaData } from '@/helpers/extractMetaData';
import { extractPageDescription } from '@/helpers/page/description/extractPageDescription';
import { extractUrls } from './useExtractUrls';

export default function useProcessPage() {
  const pagesStore = usePagesStore();
  const urlSourcesStore = useUrlSourcesStore();
  const activeUrlStore = useActiveUrlStore();

  const pagesSource = computed(() => urlSourcesStore.getPagesSource);

  watch(
    pagesSource,
    () => {
      const pagesToProcess = urlSourcesStore.getPagesSource.filter(
        (url) => !pagesStore.hasUrl(url.pathname)
      );

      pagesToProcess.forEach((page) => {
        const htmlSource = page.urlSource;
        const provider = activeUrlStore.getProvider;
        extractUrls(htmlSource);

        // Extract metadata
        const { metaTitle, metaDescription } = extractMetaData(
          htmlSource,
          provider
        );

        // Extract category description
        const description = extractPageDescription(
          htmlSource,
          page.pathname,
          provider
        );

        // Add the page to the store
        pagesStore.addPage(
          page.pathname,
          metaTitle,
          metaDescription,
          description
        );
      });
    },
    { immediate: true }
  );
}
